var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Sentry from '@sentry/browser';
import React, { Suspense } from 'react';
import LoadingIndicator from './loading';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        console.error(error);
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        Sentry.withScope(function (scope) {
            var extras = __assign({}, errorInfo);
            scope.setExtras(extras);
            Sentry.captureException(error);
            console.log(error);
        });
        // Force reload in case of missing chunk file.
        if (error.toString().indexOf('ChunkLoadError') > -1) {
            window.location.reload();
        }
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return (_jsxs("div", __assign({ className: "centered padding-top-small" }, { children: [_jsx("h2", { children: "We\u2019re sorry, something went wrong." }), _jsx("h2", { children: "Please reload this page." })] })));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
var errorBoundary = function (Component) {
    var ComponentWrapper = function (props) {
        return (_jsx(Suspense, __assign({ fallback: _jsx(LoadingIndicator, {}) }, { children: _jsx(ErrorBoundary, { children: _jsx(Component, __assign({}, props)) }) })));
    };
    return ComponentWrapper;
};
export default errorBoundary;
